// extracted by mini-css-extract-plugin
export default {"title":"_199216761f","inner_title":"_94a113123e","charge_btn":"_9966198a56"};